import React from 'react';
import InputTypesEnum from '../../Enums/InputTypesEnum';
import ValidityHelper from '../../Helpers/ValidityHelper';
import EndOfMonthItem from '../../Domain/EndOfMonthItem';
import EndOfMonthService from '../../Services/EndOfMonthService';

class EditEndOfMonthWindowDescription extends React.Component {
  static titleForCreate = 'Create End Of Month';
  static titleForEdit = 'Edit End Of Month';
  static ComponentName = 'End Of Month';
  static itemType = EndOfMonthItem;
  static serviceFunction = (edited) => EndOfMonthService.EditEndOfMonth(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'InvoiceFinalizationEndDateUtc',
          label: 'Invoice Finalization End Date',
          className: 'col-12',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.forRequiredDateTodayOrLater,
        },
        {
          fieldName: 'PaymentExportDateUtc',
          label: 'Payment Export Date *',
          className: 'col-12',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.forRequiredDateTodayOrLater,
        },
        {
          fieldName: 'IsApproved',
          label: 'Approved?',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
      ],
    },
  ];
}

export default EditEndOfMonthWindowDescription;
